// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_intro = /** @type {(inputs: {}) => string} */ () => {
	return `We want you to be completely happy with your purchase. If something isn't right, we're here to help.`
};

const el_refunds_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Θέλουμε να είστε απόλυτα ικανοποιημένοι με την αγορά σας. Αν κάτι δεν είναι σωστό, είμαστε εδώ να βοηθήσουμε.`
};

const ru_refunds_intro = /** @type {(inputs: {}) => string} */ () => {
	return `Мы хотим, чтобы вы остались полностью довольны покупкой. Если что-то не так, мы готовы помочь.`
};

const he_refunds_intro = /** @type {(inputs: {}) => string} */ () => {
	return `אנחנו רוצים שתהיו מרוצים לחלוטין מהרכישה. אם משהו לא בסדר, אנחנו כאן לעזור.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_intro(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_intro", locale)
	if (locale === "en") return en_refunds_intro(inputs)
	if (locale === "el") return el_refunds_intro(inputs)
	if (locale === "ru") return ru_refunds_intro(inputs)
	if (locale === "he") return he_refunds_intro(inputs)
	return "refunds_intro"
};